import React, { useState } from 'react';
import { Dialog, DialogContent, Button } from '@mui/material';

const CollapsibleDialog = ({ open, onClose, content }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        {content}
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default CollapsibleDialog;